import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import Loader from "../../../components/Loader/Loader";
import "../../../components/common/css/campaignview.scss";

const New = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  let token = localStorage.getItem("accessToken");
  const d = new Date(data?.updatedAt);
  const { newsId } = useParams();

  const getDataById = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${process.env.REACT_APP_API}admin/news/${newsId}`,
        { headers: { "x-access-token": token } }
      );

      setData(response.data.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Swal.fire({
        title: error?.response?.data?.message,
        timerProgressBar: true,
        icon: "error",
        confirmButtonText: "OK",
        showCloseButton: true,
      });
    }
  };

  useEffect(() => {
    getDataById();
  }, []);

  return (
    <div className="single">
      <Loader isLoading={loading} />
      <Sidebar />
      {/* <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">Edit Profile</h1>
        </div>

        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div">
              <div className="imgChange-div">
                <img src={ImgChangeIcon} alt="" className="imgChangeIcon" />
              </div>
              <input
                type="file"
                name="file"
                accept="image/png , image/jpeg"
                title=""
                className="profile-pic-select"
                onChange={(e) => profileImage(e)}
              />

              <img
                src={file ? file.preview : adminDetails?.data?.profilePic}
                alt=""
                className="setting-profile"
              />
            </div>

            {error && (
              <span style={{ color: "red" }}>
                Please upload file in jpg,jpeg and png format
              </span>
            )}
          </div>
          <div className="right">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="formInput">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstname"
                  value={data?.title}
                  placeholder="Enter First Name"
                />

              </div>
              <div className="formInput">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastname"
                 value= {
                    data?.category?.map(e => e.category).join(',')
                  }
                  placeholder="Enter Last Name"
                />
                
              </div>
              <div className="formInput">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={"akash"}
                  placeholder="Enter Email"
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email.message}</div>
                )}
              </div>
              <div className="formInput">
                <label>Phone</label>
                <input
                  type="text"
                  name="phone"
                  value={"akash"}
                  placeholder="Enter Phone"
                />
                {errors.phone && (
                  <div className="invalid-feedback">{errors.phone.message}</div>
                )}
              </div>

              
              

              <button className="submitBtn">Save</button>
            </form>
          </div>
        </div>
      </div> */}
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            {/* <div className="editButton">Edit</div> */}
            <div className="title-topSection">
              <h1 className="title">News Information</h1>
              {/* <button onClick={handleOpen} className="editButton">
                    History
                  </button> */}
            </div>
            <div className="item">
              <div className="details profile-info">
                <div className="detailItem" style={{ flexBasis: "62%" }}>
                  <span className="itemKey">News Tittle:</span>
                  <span className="itemValue">{data?.title}</span>
                </div>
                <div className="detailItem" style={{ flexBasis: "62%" }}>
                  <span className="itemKey">News Category:</span>
                  <span className="itemValue">
                    {data?.category?.map((e) => e.category).join(",")}
                  </span>
                </div>
                <div className="detailItem" style={{ flexBasis: "62%" }}>
                  <span className="itemKey">Date:</span>
                  <span className="itemValue">
                    {d?.toLocaleDateString()}
                  </span>
                </div>
                <div className="detailItem" style={{ flexBasis: "62%" }}>
                  <span className="itemKey">Status:</span>
                  <span className="itemValue">
                    {data?.status == 1 ? "Published" : "Draft"}
                  </span>
                </div>
                {/* <div className="detailItem" style={{ flexBasis: "62%" }}>
                  <span className="itemKey">Brief:&nbsp;&nbsp;&nbsp;:</span>
                  <span
                    className="itemValue"
                    dangerouslySetInnerHTML={{ __html: data?.brief }}
                  />
                </div> */}
                <div className="detailItem" style={{ flexBasis: "62%" }}>
                  <span className="itemKey">
                    Description:&nbsp;&nbsp;&nbsp;:
                  </span>
                  <span
                    className="itemValue"
                    dangerouslySetInnerHTML={{ __html: data?.description }}
                  />
                </div>
                <div className="detailItem" style={{ flexBasis: "62%" }}>
                  <span className="itemKey">Banner Image:</span>
                  <span className="itemValue">
                    {data?.bannerURL ? (
                      <img
                        src={data?.bannerURL}
                        alt="Banner"
                        style={{ maxWidth: "50%", height: "50%" }}
                      />
                    ) : (
                      "No banner image available"
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default New;
